// components/TeammateCalculations.jsx - Teammate Calculations Component
import React from 'react';
import NumberFormat from 'react-number-format';
import useTeammateCalculations from '../hooks/useTeammateCalculations';

const TeammateCalculations = ({ product, translate }) => {
  const { discount, $weight, $kasr, $ojrat, $stone_price } = useTeammateCalculations(product);

  return (
    <div className='teammate-calculations'>
      <div className='calc-item'>
        <span className='calc-value'>{$weight}</span>
      </div>
      <div className='calc-item'>
        <span className='calc-value'>{$kasr}</span>
      </div>
      <div className='calc-item'>
        <span className='calc-value'>
          <NumberFormat value={$ojrat} displayType={'text'} thousandSeparator={true} />
        </span>
      </div>
      <div className='calc-item'>
        <span className='calc-value'>
          <NumberFormat value={$stone_price} displayType={'text'} thousandSeparator={true} />
        </span>
      </div>
      <div className='calc-item'>
        <span className='calc-value'>{parseFloat(discount).toFixed(2)}</span>
      </div>
    </div>
  );
};

export default TeammateCalculations;
